/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'confluence-analytics-byline.abbreviated-user-views.message':
    '{count, plural, =0 {Visninger} one {1} other {{count}}}',
  'confluence-analytics-byline.page-viewers.message': 'Læsere',
  'confluence-analytics-byline.user-views.message':
    '{count, plural, =0 {Analyser} one {Set af 1 person} other {Set af {count} personer}}',
};
